import {
    COL_DETAIL,
    COL_TRANSIT,
    COL_TRIP,
    COL_DAILY_SUMMARY,
    COL_GEOFENCE,
    COL_REFUEL_REPORT,
    COL_EVENT,
    COL_THEFT_REPORT,
    COL_UTILISATION_REPORT,
    COL_MDVR_EVENT,
    COL_PASSENGER_COUNT,
    COL_DISCONNECTED
} from './columns'

import {
    FORMATTER_TRIP,
    FORMATTER_TRANSIT,
    FORMATTER_DETAIL,
    FORMATTER_DAILY_SUMMARY,
    FORMATTER_SUMMARY,
    FORMATTER_REFUEL_REPORT,
    FORMATTER_GEOFENCE,
    FORMATTER_THEFT_REPORT,
    FORMATTER_EVENT,
    FORMATTER_UTILISATION,
    FORMATTER_MDVR_EVENT,
    FORMATTER_PASSENGER_COUNT,
    FORMATTER_DISCONNECTED
} from './formatter' 

export * as COLUMN from './columns'

export const VEHICLE_REPORT_DEFAULT_FILTER = 'All'
export const VEHICLE_REPORT_DAY_QUERY_WINDOW = 31

export const VEHICLE_REPORT_TABLE_TYPE_KEYS = {
    TRIP: 'Trip',
    TRANSIT: 'Transit',
    DAILY_SUMMARY: 'Daily Summary',
    SUMMARY: 'Summary',
    DETAIL: 'Detail',
    GEOFENCE: 'Geofence',
    VEHICLE_UTILIZATION: 'Vehicle Utilization',
    REFUEL_REPORT: 'Refuel Report',
    THEFT_REPORT: 'Fuel Theft Report',
    EVENT: 'Event',
    MDVR_EVENT: "MDVR Event",
    PASSENGER_COUNTING: 'Passenger Counting',
    DISCONNECT: 'Disconnect',
    // Special Report
    IDLING_ANALYSIS: 'Idling Analysis'
}

export const VEHICLE_REPORT_FILE_NAME = {
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRIP]: 'trip',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRANSIT]: 'transit',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.SUMMARY]: 'summary',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DAILY_SUMMARY]: 'dailySummary',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DETAIL]: 'detail',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.GEOFENCE]: 'geofence',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.VEHICLE_UTILIZATION]: 'vehicleUtilization',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.REFUEL_REPORT]: 'refuelReport',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.THEFT_REPORT]: 'fuelTheftReport',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.EVENT]: 'event',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.MDVR_EVENT]: 'mdvrEvent',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.PASSENGER_COUNTING]: 'passengerCounting',
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DISCONNECT]: 'disconnect',
    // Special Report
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.IDLING_ANALYSIS]: 'idlingAnalysis'
}

export const VEHICLE_REPORT_QUERY_LIMIT = {
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRANSIT]: true,
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRIP]: true,
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DAILY_SUMMARY]: false,
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DETAIL]: true,
    // Special Report
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.IDLING_ANALYSIS]: true
}

export const VEHICLE_REPORT_TABLE = ({geofences, FILTER_OUT_ROLE, userRole, userCam, filterPrice, searchTextState, searchedColumnState }) => ({
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRIP]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRIP],
        columns: COL_TRIP({geofences, exportState:false, searchTextState, searchedColumnState}),
        export: COL_TRIP({geofences, exportState:true, searchTextState, searchedColumnState}),
        extra: <></>,
        dataSrcFormatter: ({vids, tripRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers}) => FORMATTER_TRIP({vids, tripRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers}),
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRANSIT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.TRANSIT],
        columns: COL_TRANSIT({geofences, exportState:false, searchTextState, searchedColumnState}),
        export: COL_TRANSIT({geofences, exportState:true, searchTextState, searchedColumnState}),
        extra: <></>,
        dataSrcFormatter: ({vids, transitRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers}) => FORMATTER_TRANSIT({vids, transitRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.SUMMARY]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.SUMMARY],
        columns: COL_DAILY_SUMMARY({geofences, filterPrice, exportState:false}),
        export: COL_DAILY_SUMMARY({geofences, filterPrice, exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({vids, vehicleReportDailySummaries, filterPrice, vehicles }) => FORMATTER_SUMMARY({vids, vehicleReportDailySummaries, filterPrice, vehicles})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DAILY_SUMMARY]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.DAILY_SUMMARY],
        columns: COL_DAILY_SUMMARY({geofences, filterPrice, exportState:false}),
        export: COL_DAILY_SUMMARY({geofences, filterPrice, exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({vids, vehicleReportDailySummaries, filterPrice, vehicles }) => FORMATTER_DAILY_SUMMARY({vids, vehicleReportDailySummaries, filterPrice, vehicles})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DETAIL]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.DETAIL],
        columns: COL_DETAIL({geofences, FILTER_OUT_ROLE, userRole, exportState:false}),
        export: COL_DETAIL({geofences, FILTER_OUT_ROLE, userRole, exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({vids, vehicleLogs, vehicleDerivativeLogs, vehicleEventLogs, vehicleGeoStateLogs, vehicles, drivers}) => FORMATTER_DETAIL({vids, vehicleLogs, vehicleDerivativeLogs, vehicleEventLogs, vehicleGeoStateLogs, vehicles, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.GEOFENCE]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.GEOFENCE],
        columns: COL_GEOFENCE({geofences, exportState:false}),
        export: COL_GEOFENCE({geofences, exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({vehicleReportGeofences, geoids, geofenceGroups, durations, vehicles, drivers}) => FORMATTER_GEOFENCE({vehicleReportGeofences, geoids, geofenceGroups, durations, vehicles, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.REFUEL_REPORT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.REFUEL_REPORT],
        columns: COL_REFUEL_REPORT({geofences, exportState:false}),
        export: COL_REFUEL_REPORT({geofences, exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers}) => FORMATTER_REFUEL_REPORT({vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.EVENT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.EVENT],
        columns: COL_EVENT({exportState:false, searchTextState, searchedColumnState}),
        export: COL_EVENT({exportState:true, searchTextState, searchedColumnState}),
        extra: <></>,
        dataSrcFormatter: ({vehicleEventLogs, drivers, vehicles}) => FORMATTER_EVENT({vehicleEventLogs, drivers, vehicles})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.THEFT_REPORT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.THEFT_REPORT],
        columns: COL_THEFT_REPORT({geofences, exportState:false, searchTextState, searchedColumnState}),
        export: COL_THEFT_REPORT({geofences, exportState:true, searchTextState, searchedColumnState}),
        extra: <></>,
        dataSrcFormatter: ({vids, vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers}) => FORMATTER_THEFT_REPORT({vids, vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.VEHICLE_UTILIZATION]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.VEHICLE_UTILIZATION],
        columns: COL_UTILISATION_REPORT({userRole}),
        export: COL_UTILISATION_REPORT({userRole}),
        extra: <></>,
        dataSrcFormatter: ({vehicles, users, vehicleUtilisation}) => FORMATTER_UTILISATION({vehicles, users, vehicleUtilisation})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.MDVR_EVENT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.MDVR_EVENT],
        columns: COL_MDVR_EVENT({ userCam, exportState:false, searchTextState, searchedColumnState}),
        export: COL_MDVR_EVENT({ userCam, exportState:true, searchTextState, searchedColumnState}),
        extra: <></>,
        dataSrcFormatter: ({ devicesMDVR, drivers }) => FORMATTER_MDVR_EVENT({devicesMDVR, drivers})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.PASSENGER_COUNTING]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.PASSENGER_COUNTING],
        columns: COL_PASSENGER_COUNT({exportState:false}),
        export: COL_PASSENGER_COUNT({exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({ devicesMDVR, vehicles }) => FORMATTER_PASSENGER_COUNT({devicesMDVR, vehicles})
    },
    [VEHICLE_REPORT_TABLE_TYPE_KEYS.DISCONNECT]: {
        title: [VEHICLE_REPORT_TABLE_TYPE_KEYS.DISCONNECT],
        columns: COL_DISCONNECTED({exportState:false}),
        export: COL_DISCONNECTED({exportState:true}),
        extra: <></>,
        dataSrcFormatter: ({ devicesMDVR, vehicles }) => FORMATTER_DISCONNECTED({devicesMDVR, vehicles})
    },
})